export const addNotification = (notification) => ({
    type: 'GLOBAL_NOTIFICATION_ADD',
    notification,
})

export const removeNotification = (id) => ({
    type: 'GLOBAL_NOTIFICATION_REMOVE',
    id,
})
